import { GetMovimientosTarjetaBancariaByFiltersDtoProps } from "api/DTOs/GetMovimientosTarjetaBancariaByFiltersDto"
import { TipoTransaccionType } from "api/Types/TipoTransaccionEnum"
import { ColoredNumber } from "features/Contabilidad/components/ColoredNumber"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

export const MOVIMIENTOS_BANCARIOS_COLUMNS = ({ t }: { t: TFunction }) => {
  const columns = [
    {
      key: "fechaOperacion",
      field: "fechaOperacion",
      header: `${t("bancos.cardsTable.detail.table.dateOperation")}`,
      body: ({
        fechaOperacion,
      }: GetMovimientosTarjetaBancariaByFiltersDtoProps) =>
        fechaOperacion ? frontendDateFormat(new Date(fechaOperacion)) : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "BookingDate",
    },
    {
      key: "fechaValor",
      field: "fechaValor",
      header: `${t("bancos.cardsTable.detail.table.dateValue")}`,
      body: ({ fechaValor }: GetMovimientosTarjetaBancariaByFiltersDtoProps) =>
        fechaValor ? frontendDateFormat(new Date(fechaValor)) : "-",
      style: { width: "10%" },
      sortable: true,
      sortField: "valueDate",
    },
    {
      key: "descripcion",
      field: "description",
      header: `${t("bancos.cardsTable.detail.table.description")}`,
      body: ({ descripcion }: GetMovimientosTarjetaBancariaByFiltersDtoProps) =>
        descripcion ?? "-",
      sortable: true,
      sortField: "description",
    },
    {
      key: "importe",
      field: "importe",
      header: `${t("bancos.cardsTable.detail.table.import")}`,
      body: ({ importe }: GetMovimientosTarjetaBancariaByFiltersDtoProps) =>
        importe && !Number.isNaN(importe) ? ColoredNumber(importe) : "-",
      bodyClassName: `!tw-text-end tw-font-medium`,
      alignCol: "right",
      style: { width: "15%" },
      sortable: true,
      sortField: "amount",
    },
  ]

  return columns
}

export type tarjetaDetailFiltersProps = {
  id?: string
  activeCompanyId?: string
  keyword?: string
  pagination: {
    itemsPerPage: number
    skipCount: number
  }
  date: {
    min?: string
    max?: string
  }
  amount: {
    min?: number
    max?: number
  }
  movementType?: TipoTransaccionType
}

export const TARJETA_DETAIL_FILTERS = (
  id?: string,
  activeCompanyId?: string,
  itemsPerPage?: number
) => ({
  id,
  idExterno: null,
  activeCompanyId,
  keyword: undefined,
  pagination: {
    itemsPerPage: itemsPerPage ?? 100,
    skipCount: 0,
  },
  date: { min: undefined, max: undefined },
  amount: { min: undefined, max: undefined },
  movementType: undefined,
})
